import { CanActivateFn } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import {GenRoleDefinition} from '../../generated/serverModels/GenRoleDefinition';

export const userRoleGuard: CanActivateFn = (next) => {
  const user = AuthService.getAuthenticatedUserValue();
  if (next.data === undefined) {
    throw new Error('You cannot access this route. Please contact an administrator.');
  }

  if (!user) {
    return false;
  }

  if(next.data['requiredRoles']) {
    const roles: GenRoleDefinition[] = next.data['requiredRoles'];
    return user.hasAnyRole(roles);
  }

  return user.isAdmin();
};
